import React, {
  useReducer,
  createContext,
  useState,
  useEffect,
  useContext,
} from "react";
import { useGET } from "@API2";
import { UserEndpoints } from "@USERS";
import { FiltersContext } from "@CONTEXTS";

export const UserContext = createContext({});

const initialState = {
  data: [],
};

const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case "SET_DATA":
      return {
        ...state,
        data: payload,
      };
    default:
      break;
  }
};

const UserProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [loading, setLoading] = useState(true);
  const filterState = useContext(FiltersContext);

  const {
    data = [],
    loading: apiloading,
    error,
    mutate,
  } = useGET(
    `${UserEndpoints.getAll}`,
    filterState.filters
      ? `?firstName=${
          filterState.filters.firstName ? filterState.filters.firstName : ""
        }&lastName=${
          filterState.filters.lastName ? filterState.filters.lastName : ""
        }&email=${filterState.filters.email ? filterState.filters.email : ""}`
      : false
  );

  useEffect(() => {
    if (!apiloading) {
      setLoading(false);
    }
  }, [apiloading]);

  return (
    <UserContext.Provider
      value={{
        ...state,
        dispatch,
        data,
        loading,
        error,
        mutate,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
